function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Chevron/Left End");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Chevron/Left-End",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.7125882,16.6930554 L16.6778808,22.7128971 C16.2931768,23.095701 15.6706471,23.095701 15.287118,22.7128971 C14.904294,22.3300933 14.904294,21.7091214 15.287118,21.326552 L20.626914,15.9998828 L15.288058,10.6741513 C14.904294,10.2913475 14.904294,9.6706099 15.288058,9.2878061 C15.6715871,8.90406463 16.2941168,8.90406463 16.6778808,9.2878061 L22.7125882,15.3076479 C22.9045877,15.4989326 23,15.7490561 23,15.9998828 C23,16.2507095 22.9045877,16.5027084 22.7125882,16.6930554 Z",
  transform: "translate(19.000000, 16.000000) scale(-1, 1) translate(-19.000000, -16.000000) "
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 8,
  width: 2,
  height: 16,
  rx: 1
}));

var SvgLeftEnd = function SvgLeftEnd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftEnd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeftEnd.3a28b848.svg";
export { ForwardRef as ReactComponent };